// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />

export default class TestImage {

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }

    private onLoad(app: vf.Application, uiStage: vf.gui.Stage) {
        let url = "//s.vipkidstatic.com/vf/plugin/Matter/0.0.1.js?112233";
        this.importScript(url, 'Matter', (Matter: any, className: string) => {
            //天花板
            const basicText = new vf.gui.Label();
            basicText.style.color = 0xffffff;
            basicText.text = "Matter physics test";
            basicText.pivotX = 100;
            basicText.pivotY = 16;
            basicText.style.backgroundColor = 0xff0000;
            uiStage.addChild(basicText);

            const rect = new vf.gui.Rect();
            rect.color = 0xff00ff;
            rect.width = 800;
            rect.height = 20;
            rect.anchorY = 0.5;
            rect.anchorX = 0.5;
            uiStage.addChild(rect);

            let matter = new Matter();
            uiStage.addChild(matter);
            matter.options = {
                mouseConstraint: true
            }
            matter.bodies = [
                {
                    id: 0,
                    shape: 'rectangle',
                    width: 200, 
                    height: 32,
                    displayObject: basicText,
                    friction: 0,
                    x: 200,
                    y: 400,
                    isStatic: true
                },
                {
                    id: 1,
                    shape: 'rectangle',
                    width: 800,
                    height: 20,
                    displayObject: rect,
                    friction: 1,
                    isStatic: true,
                    angle: 0.1,
                    x: 300,
                    y: 600
                }
            ]



            let bodyInfo: any = {
                id: 301,
                shape: 'circle',
                width: 40,
                height: 40,
                radius: 20,
                displayObject: '',
                density: 0.5,
                restitution: 0.5,
                friction: 10,
                frictionAir: 0.01,
                frictionStatic: 0.5,
                timeScale: 1,
                x: 200,
                y: 0,
                group: 1,
                collision: false
            }

            function newBody(){
                let sprite = new vf.gui.Image();
                sprite.id = 'sprite';
                sprite.src = '//vipkid-edu.github.io/vf-examples/assets/matter/bird.png';
                sprite.anchorX = 0.5;
                sprite.anchorY = 0.5;
                uiStage.addChild(sprite);
                bodyInfo.displayObject = sprite;
                bodyInfo.x = 200 + Math.random() * 10 - 5;

                matter.newBody(bodyInfo);
            }

            matter.world.on('collisionStart', (bodyA: any, bodyB: any) => {
                console.log('collisionStart');
                bodyA.displayObject && (bodyA.displayObject.tint = '0x00ffff');
                bodyB.displayObject && (bodyB.displayObject.tint = '0x00ffff');
            })

            matter.world.on('collisionEnd', (bodyA: any, bodyB: any) => {
                bodyA.displayObject && (bodyA.displayObject.tint = '0xffffff');
                bodyB.displayObject && (bodyB.displayObject.tint = '0xffffff');
            })

            this.getButton('新建刚体', () => {
                newBody();
            }, uiStage, 500, 350);

            this.getButton('开/关碰撞检测', () => {
                bodyInfo.collision = !bodyInfo.collision;
                for(let i = 0; i < matter.world.bodies.length; ++i){
                    let body = matter.world.bodies[i];
                    body.collision = bodyInfo.collision;
                    if(!body.collision && body.displayObject){
                        body.displayObject.tint = '0xffffff';
                    }
                }
            }, uiStage, 650, 350);

            this.getButton('新建软体布', () => {
                matter.cloth(200, 200, 200, 100, 1, '//vipkid-edu.github.io/vf-examples/assets/matter/cloth.png')
            }, uiStage, 500, 400);

            this.getButton('批量创建刚体', () => {
                bodyInfo.shape = 'rectangle';
                matter.stack(100, 0, 5, 5, bodyInfo, 0xffff00);
                bodyInfo.shape = 'circle';
            }, uiStage, 650, 400);

            this.getButton('刚体发射器', () => {
                matter.emitBodies(100, 100, 20, 2, bodyInfo, 0xff0000);
            }, uiStage, 500, 450);

            this.getButton('移除所有刚体', () => {
                matter.removeAllBodies(false);
            }, uiStage, 650, 450);

            this.getSlider('密度(0.01-1):', (slider: vf.gui.CheckBox, curValue: number) => {

                bodyInfo.density = curValue / 100.0;
            }, uiStage, 500, 50);

            this.getSlider('弹力(0.01-1):', (slider: vf.gui.CheckBox, curValue: number) => {
                bodyInfo.restitution = curValue / 100.0;
            }, uiStage, 500, 100);

            this.getSlider('摩擦力(0.01-1):', (slider: vf.gui.CheckBox, curValue: number) => {
                bodyInfo.friction = curValue / 100.0;
            }, uiStage, 500, 150);

            this.getSlider('浮力(0.01-1):', (slider: vf.gui.CheckBox, curValue: number) => {
                bodyInfo.frictionAir = curValue / 100.0;
            }, uiStage, 500, 200, 1);

            this.getSlider('时间缩放(0.01-1):', (slider: vf.gui.CheckBox, curValue: number) => {
                bodyInfo.timeScale = curValue / 100.0;
            }, uiStage, 500, 250, 100);

            this.getSlider('静摩擦(0.01-1):', (slider: vf.gui.CheckBox, curValue: number) => {
                bodyInfo.frictionStatic = curValue / 100.0;
            }, uiStage, 500, 300);
        })
    }

    private getButton(title: string, fun: Function, target: any, x: number, y: number) {
        const button = new vf.gui.Label;
        button.style.fontSize = 24;
        button.style.fontFamily = 'PingFang-SC-Medium,PingFang-S';
        button.style.fontWeight = 500;
        button.style.color = 0xffffff;
        button.style.lineHeight = 45;
        button.text = title;
        button.interactabled = true;
        button.x = x;
        button.y = y;
        button.on(vf.gui.Interaction.TouchMouseEvent.onClick, fun);
        target.addChild(button);
    }

    private getSlider(title: string, fun: Function, target: any, x: number, y: number, value: number = 50){
        const label = new vf.gui.Label;
        label.style.fontSize = 20;
        label.style.color = 0x555555;
        label.style.lineHeight = 45;
        label.text = title;
        label.x = x;
        label.y = y;
        target.addChild(label);

        const slider = new vf.gui.Slider();
        slider.vertical = false;
        slider.thumb = "//vipkid-edu.github.io/vf-examples/assets/skin/Slider/thumb.png";
        slider.track = "//vipkid-edu.github.io/vf-examples/assets/skin/Slider/track.png";
        slider.tracklight = "//vipkid-edu.github.io/vf-examples/assets/skin/Slider/tracklight.png";
        slider.style.width = 100;
        slider.style.height = 5;
        slider.style.top = y + 10;
        slider.style.left = x + 150;
        slider.value = value;
        slider.on(vf.gui.Interaction.ComponentEvent.CHANGE, fun);
        target.addChild(slider);
    }

    private importScript(url: string, moduleName: string, callBack: any){
    
        var _namespace : any = vf.gui;
        
        if(_namespace[moduleName]){
            throw new Error('模块命名冲突');
        }
    
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = false;
        script.src = url;
    
        const loadError = (e: any) => {
            return callBack(e);
        };
        
        const loadCallback = () => {
            if (script && script.parentNode) {
                script.parentNode.removeChild(script);
            }
            // tslint:disable-next-line: no-arg
            script.removeEventListener('load', loadCallback, false);
            script.removeEventListener('error', loadError, false);
    
            const module = _namespace.module;
            if(moduleName){
                if(module.hasOwnProperty(moduleName)){
                    _namespace[moduleName] = module[moduleName];
                    _namespace.module = null;
                    if(_namespace[moduleName].isFilter){
                        _namespace.Filter.list.set(moduleName,_namespace[moduleName]);
                    }
                    return callBack(_namespace[moduleName],moduleName);
                }
                return callBack(undefined);
            }
            return callBack(true);
        };
        
        // tslint:disable-next-line: only-arrow-functions
        script.addEventListener('load', loadCallback, false);
        script.addEventListener('error', loadError, false);
        document.body.appendChild(script);
    
    }
}